import React from 'react';

import PropTypes from 'prop-types';
import { Form, Input, TextArea, Dropdown, Header } from 'semantic-ui-react';

import {
  DELAY_UNIT_OPTIONS,
  DEFAULT_DELAY_QUANTITY,
  DEFAULT_DELAY_UNIT,
} from './GenerationSettings.constants';
import { GenerationSettingsPropType } from './GenerationSettings.types';
import {
  MANUAL_RESPONSE_TYPE,
  TEMPLATE_GENERATION_TYPE,
  AI_GENERATION_TYPE,
  AUTOMATIC_RESPONSE_TYPE,
} from '../ResponseSettingsForm/ResponseSettingsForm.constants';

import './GenerationSettings.scss';

const propTypes = {
  settings: GenerationSettingsPropType.isRequired,
  onChange: PropTypes.func.isRequired,
  providerServiceSettingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const defaultProps = {};

export default function GenerationSettings({ settings, onChange, providerServiceSettingId }) {
  const idPrefix = providerServiceSettingId;
  const { type, generator, incentive, delay = {}, template, instructions } = settings || {};
  const { unit: delayUnit = '', quantity: delayQuantity } = delay;

  const isManual = type === MANUAL_RESPONSE_TYPE;
  const isAutomatic = type === AUTOMATIC_RESPONSE_TYPE;

  const isTemplate = generator === TEMPLATE_GENERATION_TYPE;
  const isAI = generator === AI_GENERATION_TYPE;

  if (isManual) return null;

  const showTemplate = isTemplate;
  const showInstructions = isAI;
  const showIncentive = isAI;
  const showDelay = isAutomatic;

  return (
    <div className="generation-settings">
      <Header as="h4">Generation Settings</Header>
      {showTemplate && (
        <Form.Field>
          <label htmlFor={`${idPrefix}-template`}>Template</label>
          <TextArea
            id={`${idPrefix}-template`}
            value={template}
            onChange={(e, { value: newTemplate }) => onChange('template', newTemplate)}
            placeholder="Thanks for your review! We're glad you chose us..."
            rows={2}
            style={{ minHeight: 60, fontSize: 15 }}
          />
        </Form.Field>
      )}
      {showInstructions && (
        <Form.Field>
          <label htmlFor={`${idPrefix}-instructions`}>How should your assistant respond?</label>
          <TextArea
            id={`${idPrefix}-instructions`}
            value={instructions}
            onChange={(e, { value: newInstructions }) => onChange('instructions', newInstructions)}
            placeholder="How should replies be written?"
            rows={3}
            style={{ minHeight: 60, fontSize: 15 }}
          />
        </Form.Field>
      )}
      {showIncentive && (
        <Form.Field>
          <label htmlFor={`${idPrefix}-incentive`}>Do you want to offer an incentive?</label>
          <Input
            id={`${idPrefix}-incentive`}
            value={incentive}
            onChange={(e, { value: newIncentive }) => onChange('incentive', newIncentive)}
            placeholder="We want to offer you 10% off your next service. Please reference this review on your next visit..."
            style={{ width: '100%' }}
          />
        </Form.Field>
      )}
      {showDelay && (
        <Form.Group widths="equal">
          <Form.Field>
            <label htmlFor={`${idPrefix}-delay-unit`}>How frequently do you want to respond?</label>
            <Dropdown
              id={`${idPrefix}-delay-unit`}
              selection
              options={DELAY_UNIT_OPTIONS}
              value={delayUnit}
              onChange={(e, { value: newDelayUnit }) =>
                onChange('delay', { ...delay, unit: newDelayUnit || DEFAULT_DELAY_UNIT })
              }
              fluid
              aria-labelledby={`${idPrefix}-delay-unit`}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor={`${idPrefix}-delay-quantity`}>
              How many {delayUnit.toLowerCase()} until the assistant responds?
            </label>
            <Input
              id={`${idPrefix}-delay-quantity`}
              type="number"
              min={1}
              step={1}
              fluid
              value={delayQuantity}
              onChange={(e, { value: newDelayQuantity }) =>
                onChange('delay', {
                  ...delay,
                  quantity: +newDelayQuantity || DEFAULT_DELAY_QUANTITY,
                })
              }
            />
          </Form.Field>
        </Form.Group>
      )}
    </div>
  );
}

GenerationSettings.propTypes = propTypes;
GenerationSettings.defaultProps = defaultProps;
